import { createIntlCache, createIntl } from 'react-intl'
import messages from '../i18n/messages.json'
import { getLang } from 'mailup-react-helpers'

let intlInstance = null

/**
 * @returns standalone intl utility
 *
 */
const getIntl = () => {
  if (!intlInstance) {
    const l = getLang()
    const cache = createIntlCache()
    intlInstance = createIntl({ messages: messages[l], locale: l }, cache)
  }
  return intlInstance
}

export default getIntl
